import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined';

import ActionButton from '../../../../../components/ActionButton/ActionButton';
import ContentRow from '../../../../../components/ContentRow/ContentRow.js';

import { getString } from '../../../../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'contactDetails';

class EmergencyContactsCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      classes,
      contact1name,
      contact1phone,
      contact1updating,
      contact2name,
      contact2phone,
      contact2updating,
      editAction,
      removeAction,
      addFab,
      canEdit,
    } = this.props;

    return (
      <div className={classes.root}>
        <Grid container spacing={16}>
          <Grid item xs={12}>
            {contact1name && contact1phone && (
              <div className={classes.iconFieldWrapper}>
                <div className={classes.iconLabelWrapper}>
                  <PersonOutlinedIcon className={`${classes.icon} ItemIcon`} />
                  <div>
                    <Typography
                      className={`${classes.label} ${classes.labelMobile}`}
                    >
                      {getString(stringsComponent, 'EMERGENCY_CONTACTS_LABEL')}
                    </Typography>
                  </div>
                </div>
                <div className={classes.detailsWrapper}>
                  <Typography
                    className={`${classes.label} ${classes.labelDesktop}`}
                  >
                    {getString(stringsComponent, 'EMERGENCY_CONTACTS_LABEL')}
                  </Typography>
                  <ContentRow customClass={classes.contentRow}>
                    <div className={classes.content}>
                      <Typography className={classes.value}>
                        {contact1name} | {contact1phone}
                      </Typography>
                    </div>
                    {canEdit && (
                      <div className={classes.actions}>
                        {contact1updating ? (
                          <Typography
                            compoment='span'
                            className={classes.updating}
                          >
                            {getString(stringsComponent, 'UPDATING_TEXT')}
                          </Typography>
                        ) : (
                          <React.Fragment>
                            <ActionButton
                              icon={EditIcon}
                              action={() => editAction(0)}
                              label={getString('profile', 'EDIT_BUTTON_LABEL')}
                              labelHidden={false}
                              withBorder={true}
                              withPadding={true}
                            />
                            &nbsp;
                            {removeAction && (
                              <ActionButton
                                icon={DeleteOutlineIcon}
                                action={() => removeAction(0)}
                                label={getString(
                                  'profile',
                                  'REMOVE_BUTTON_LABEL'
                                )}
                                withBorder={true}
                              />
                            )}
                          </React.Fragment>
                        )}
                      </div>
                    )}
                  </ContentRow>
                </div>
              </div>
            )}
            {contact2name && contact2phone && (
              <div className={classes.iconFieldWrapper}>
                <div className={classes.iconLabelWrapper}>
                  <PersonOutlinedIcon className={`${classes.icon} ItemIcon`} />
                  <div>
                    <Typography
                      className={`${classes.label} ${classes.labelMobile}`}
                    >
                      {getString(stringsComponent, 'EMERGENCY_CONTACTS_LABEL')}
                    </Typography>
                  </div>
                </div>
                <div className={classes.detailsWrapper}>
                  <Typography
                    className={`${classes.label} ${classes.labelDesktop}`}
                  >
                    {getString(stringsComponent, 'EMERGENCY_CONTACTS_LABEL')}
                  </Typography>
                  <ContentRow customClass={classes.contentRow}>
                    <div className={classes.content}>
                      <Typography className={classes.value}>
                        {contact2name} | {contact2phone}
                      </Typography>
                    </div>
                    {canEdit && (
                      <div className={classes.actions}>
                        {contact2updating ? (
                          <Typography
                            compoment='span'
                            className={classes.updating}
                          >
                            {getString(stringsComponent, 'UPDATING_TEXT')}
                          </Typography>
                        ) : (
                          <React.Fragment>
                            <ActionButton
                              icon={EditIcon}
                              action={() => editAction(1)}
                              label={getString('profile', 'EDIT_BUTTON_LABEL')}
                              labelHidden={false}
                              withBorder={true}
                              withPadding={true}
                            />
                            &nbsp;
                            {removeAction && (
                              <ActionButton
                                icon={DeleteOutlineIcon}
                                action={() => removeAction(1)}
                                label={getString(
                                  'profile',
                                  'REMOVE_BUTTON_LABEL'
                                )}
                                withBorder={true}
                              />
                            )}
                          </React.Fragment>
                        )}
                      </div>
                    )}
                  </ContentRow>
                </div>
              </div>
            )}
            {addFab && <div className={classes.actionContainer}>{addFab}</div>}
          </Grid>
        </Grid>
      </div>
    );
  }
}

EmergencyContactsCard.propTypes = {
  classes: PropTypes.object.isRequired,
  canEdit: PropTypes.bool.isRequired,
  addFab: PropTypes.object,
};

EmergencyContactsCard.defaultProps = {
  addFab: null,
};

export default withStyles(styles, { withTheme: true })(EmergencyContactsCard);
